import { ComponentProps, FC, PropsWithChildren } from 'react';
import cx from 'classnames';
import { CatButton } from '@blocks-react/components/Button';
import { CatIconSearch } from '@blocks-react/components/Icons/Search';
import styles from './HeaderEquipmentSearchIcon.module.scss';

type CatButtonProps = ComponentProps<typeof CatButton> & {
  isSearchBarInHeader: boolean;
};
export const HeaderEquipmentSearchIcon: FC<
  PropsWithChildren<CatButtonProps>
> = ({ isSearchBarInHeader, ...buttonProps }) => (
  <CatButton
    slot="custom"
    variant="primary"
    hideText
    className={cx(styles['searchIcon'], {
      [styles['searchIcon__search-banner']]: !isSearchBarInHeader,
      [styles['searchIcon__non-search-banner']]: isSearchBarInHeader
    })}
    data-testid="header-search-button"
    {...buttonProps}
  >
    <CatIconSearch slot="before" />
  </CatButton>
);
